<template>
  <div class="main-wrap">
    <div id="main-content">
      <div class="wrapper">
        <div class="table-agile-info">
          <jm-crumbs/>
          <div class="this-title">
            <span>学生姓名：{{ this.dataList.info.custom_name }}</span>
            <span>入学期：{{ this.dataList.info.custom_year_str }}</span>
            <span>申请学校：{{ this.dataList.interview.school_name }}</span>
          </div>
          <div class="basic-title"><em>留学规划书</em></div>
          <div class="this-process-area">
            <!--保存过的页面添加active类-->
            <div :class="tabShow === 1 ? 'process-area is-edit' : 'process-area active'" @click="tabClick(1)">
              <span>基本信息</span>
              <i></i>
            </div>
            <div :class="tabShow === 2 ? 'process-area is-edit' : 'process-area active'" @click="tabClick(2)">
              <span>留学评估</span>
              <i></i>
            </div>
            <div :class="tabShow === 3 ? 'process-area is-edit' : 'process-area active'" @click="tabClick(3)">
              <span>留学老师</span>
              <i></i>
            </div>
            <div :class="tabShow === 4 ? 'process-area is-edit' : 'process-area active'" @click="tabClick(4)">
              <span>留学时间轴</span>
              <i></i>
            </div>
            <div :class="tabShow === 5 ? 'process-area is-edit' : 'process-area active'" @click="tabClick(5)">
              <span>留学费用</span>
              <i></i>
            </div>
            <div :class="tabShow === 6 ? 'process-area is-edit' : 'process-area active'" @click="tabClick(6)">
              <span>语言学校介绍</span>
              <i></i>
            </div>
            <div :class="tabShow === 7 ? 'process-area is-edit' : 'process-area active'" @click="tabClick(7)">
              <span>生成规划书</span>
            </div>
          </div>
          <div class="this-content-wrap">
            <div class="this-content" v-show="tabShow === 1">
              <h3>基本信息</h3>
              <div class="content-area">
                <el-row>
                  <el-col :span="6">
                    <div class="content-text">
                      <span>姓名：<em>{{ this.dataList.info.custom_name }}</em></span>
                    </div>
                  </el-col>
                  <el-col :span="6">
                    <div class="content-text">
                      <span>申请学期：<em>{{ this.dataList.interview.custom_year_str?this.dataList.interview.custom_year_str:this.dataList.info.custom_year_str }}</em></span>
                    </div>
                  </el-col>
                  <el-col :span="6">
                    <div class="content-text">
                      <span>申请语言学校：<em>{{ this.dataList.interview.school_name }}</em></span>
                    </div>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="6">
                    <div class="content-text">
                      <span>学历：<em>{{ this.dataList.interview.final_edu_name }}</em></span>
                    </div>
                  </el-col>
                  <el-col :span="6">
                    <div class="content-text">
                      <span>最终毕业院校：<em>{{ this.dataList.interview.signup_form.final_school }}</em></span>
                    </div>
                  </el-col>
                  <el-col :span="6">
                    <div class="content-text">
                      <span>最终学历专业：<em>{{ this.dataList.interview.signup_form.final_subject }}</em></span>
                    </div>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="6">
                    <div class="content-input">
                      <span>日语能力：</span>
                      <el-input v-model="pageData.japanese_level" class="jm-input-common2"/>
                    </div>
                  </el-col>
                  <el-col :span="6">
                    <div class="content-input">
                      <span>英语能力：</span>
                      <el-input v-model="pageData.english_level" class="jm-input-common2"/>
                    </div>
                  </el-col>
                  <el-col :span="6">
                    <div class="content-input">
                      <span>是否升学：</span>
                      <el-select
                        class="jm-input-common2"
                        v-model="pageData.is_higher_grade"
                        clearable
                        placeholder="请选择">
                        <el-option
                          label="是"
                          value="1"/>
                        <el-option
                          label="否"
                          value="0"/>
                      </el-select>
                    </div>
                  </el-col>
                </el-row>
                <el-row>
                  <!-- <el-col :span="6">
                    <div class="content-input">
                      <span>学部/大学院：</span>
                      <el-select
                        class="jm-input-common2"
                        v-model="pageData.school_type"
                        clearable
                        placeholder="请选择">
                        <el-option label="学部" value="2"/>
                        <el-option label="大学院文科" value="3"/>
                        <el-option label="大学院理科" value="5"/>
                        <el-option label="艺术" value="4"/>
                      </el-select>
                    </div>
                  </el-col> -->
                  <el-col :span="6">
                    <div class="content-input">
                      <span>赴日攻读专业：</span>
                      <el-input v-model="pageData.study_major" class="jm-input-common2"/>
                    </div>
                  </el-col>
                  <el-col :span="6">
                    <div class="content-input">
                      <span>目标院校：</span>
                      <el-input v-model="pageData.target_school" class="jm-input-common2"/>
                    </div>
                  </el-col>
                </el-row>
              </div>
            </div>
            <div class="this-content" v-show="tabShow === 2">
              <h3>留学评估</h3>
              <div class="content-area">
                <quill-editor
                  v-model="pageData.study_assessing"
                  :options="editorOption"/>
              </div>
            </div>
            <div class="this-content" v-show="tabShow === 3">
              <h3>留学老师</h3>
              <div class="teacher-area">
                <h4>咨询老师</h4>
                <img :src="this.dataList.info.crm_sayer_img" alt="">
                <h5>{{ this.dataList.info.crm_sayer_str }}</h5>
                <p>解答留学相关疑问<br>协助申请赴日语言学校入学资格</p>
              </div>
              <div class="teacher-area">
                <h4>规划老师</h4>
                <img :src="this.dataList.info.crm_planning_img" alt="">
                <h5>{{ this.dataList.info.crm_planning_str }}</h5>
                <p>专属升学规划<br>日本生活解答<br>海外租房</p>
              </div>
              <div class="teacher-area">
                <h4>申请老师</h4>
                <img :src="this.dataList.info.crm_writer_img" alt="">
                <h5>{{ this.dataList.info.crm_writer_str }}</h5>
                <p>指导办理材料、签证<br>联系院校</p>
              </div>
            </div>
            <div class="this-content" v-show="tabShow === 4">
              <h3>
                留学时间轴
                <el-select class="jm-input-common5" v-model="dataChoose" @change="changeSchoolType" clearable placeholder="请选择">
                  <!-- <el-option label="语学院" value="1"/> -->
                  <el-option label="学部" value="2"/>
                  <el-option label="大学院文科" value="3"/>
                  <el-option label="大学院理科" value="5"/>
                  <el-option label="艺术" value="4"/>
                </el-select>
                <span v-if="this.dataList.info.custom_month === 7">七月方案</span>
                <el-select class="jm-input-common5" v-model="pageData.july_plan" clearable placeholder="请选择" v-if="this.dataList.info.custom_month === 7" @change="changeSchoolType1">
                  <el-option label="七月方案一" value="1"/>
                  <el-option label="七月方案二" value="2"/>
                </el-select>
              </h3>
              <div class="time-title">
                赴日前（语言学校）：
              </div>
              <div class="time-wrap">
                <div class="time-line"></div>
                <!--赴日前循环 start-->
                <div class="time-content" v-for="(item, index) in this.dataList.timeLine.first" :key="index">
                  <i></i>
                  <div class="left-area">{{ item.title }}<br>（{{ item.title_content }}）</div>
                  <div class="right-area">{{ item.year }}年{{ item.time }}月</div>
                  <div class="control-area">
                    <span @click="createdFirst(index)">+</span>
                    <span @click="deletedFirst(index)">-</span>
                  </div>
                </div>
                <!-- <div class="time-content">
                  <i></i>
                  <div class="left-area">开始办理材料<br>（文案老师全程指导）</div>
                  <div class="right-area">2021年9月</div>
                  <div class="control-area">
                    <span>+</span>
                    <span>-</span>
                  </div>
                </div> -->
                <!--赴日前循环 end-->
              </div>
              <div class="time-title">
                <p v-show="dataChoose == 2">赴日后（学部）：</p>
                <p v-show="dataChoose == 3">赴日后（大学院文科）：</p>
                <p v-show="dataChoose == 4">赴日后（艺术）：</p>
                <p v-show="dataChoose == 5">赴日后（大学院理科）：</p>
              </div>
              <div class="time-wrap">
                <div class="time-line"></div>
                <!--赴日后循环 start-->
                <div class="time-content" v-for="(item, index) in dataList.timeLine.second" :key="index">
                  <i></i>
                  <div class="left-area">{{ item.title }}<br>{{ item.title_content?'('+item.title_content+')':'' }}</div>
                  <div class="right-area">{{ item.year }}年{{ item.time }}月</div>
                  <div class="control-area">
                    <span @click="createdSecond(index)">+</span>
                    <span @click="deletedSecond(index)">-</span>
                  </div>
                </div>
                <!-- <div class="time-content">
                  <i></i>
                  <div class="left-area">开始办理材料<br>（文案老师全程指导）</div>
                  <div class="right-area">2021年9月</div>
                  <div class="control-area">
                    <span>+</span>
                    <span>-</span>
                  </div>
                </div> -->
                <!--赴日后循环 end-->
              </div>
              <div class="time-endcontent">
                {{ this.dataList.year }}年4月入学
              </div>
              <div class="memo-btn-wrap">
                <div class="time-title">
                  备注：
                </div>
                <div class="btn-area">

                  <em class="active" v-for="(item, index) in dataList.timeLine.comment" v-if="index < 3" :key="index">{{ item.title }}</em>
                  <!-- <em class="active">{{ item }}</em>
                  <em>材料递交入管局</em>
                  <em>在留许可下达</em>
                  <em>赴日</em> -->

                </div>
              </div>
              <div class="memo-list-wrap">
                <!--循环 start-->
                <div class="memo-list-content" v-for="(item, index) in dataList.timeLine.comment" v-if="index < 4" :key="index">
                  <div class="title-area">
                    <b>{{ index+1 }}、{{ item.title }}</b>
                    <span @click="deleteItem(index)">删除</span>
                  </div>
                  <div class="content-area">
                    <el-input
                      type="textarea"
                      :rows="5"
                      style="resize: none"
                      class="jm-input-common6"
                      placeholder=""
                      v-model="item.comment">
                    </el-input>
                  </div>
                </div>
                <!--循环 end-->
              </div>
            </div>
            <div class="this-content" v-show="tabShow === 5">
              <h3>留学费用</h3>
              <div class="content-area">
                <quill-editor
                  v-model="pageData.expenditure"
                  :options="editorOption"/>
              </div>
              <h3>打工</h3>
              <div class="content-area">
                <quill-editor
                  v-model="pageData.expenditure_job"
                  :options="editorOption"/>
              </div>
            </div>
            <div class="this-content" v-show="tabShow === 6">
              <h3>语言学校介绍</h3>
              <div class="content-area">
                <div class="school-name">
                  <img :src="this.dataList.school.school_icon" alt="">
                  <b>{{ this.dataList.school.sh_name_cn }}</b>
                </div>
                <div class="school-title">面试招生官</div>
                <div class="school-content1">
                  <img :src="this.dataList.school.school_officer.picture_head" alt="">
                  <p>{{ this.dataList.school.school_officer.introduction }}</p>
                </div>
                <div class="school-title">学校环境</div>
                <div class="school-content2">
                  <img v-for="(item, index) in this.dataList.school.school_imgs" :key="index" :src="item" />
                </div>
                <div class="school-title">地址</div>
                <div class="school-content3">
                  <p>{{ this.dataList.school.sh_address }}</p>
                  <img src="@/assets/images/img-checkin-success.jpg" alt="">
                </div>
              </div>
            </div>
            <div class="this-content" v-show="tabShow === 7">
              <h3>生成规划书</h3>
              <div class="success-area">
                <img src="@/assets/images/icon-success.png" alt="">
                <span>已生成</span>
              </div>
            </div>
          </div>
          <div class="this-btn-wrap">
            <el-button type="primary" v-if="tabShow > 1" @click="tabChange(1)">上一步</el-button>
            <el-button type="primary" v-if="tabShow < 7" @click="tabChange(2)">下一步</el-button>
            <el-button type="primary" v-if="tabShow === 7" @click="copyLink">复制H5链接</el-button>
            <el-button type="primary" v-if="tabShow === 7" @click="makeQrcode">生成推广图片</el-button>
          </div>
          <!-- 添加赴日前时间轴 -->
          <el-dialog title="添加时间轴" :visible.sync="dialogFormVisible">
            <el-form>
              <el-form-item label="阶段名称" :label-width="formLabelWidth">
                <el-input v-model="createData1.title" auto-complete="off"></el-input>
              </el-form-item>
              <el-form-item label="内容" :label-width="formLabelWidth">
                <el-input v-model="createData1.title_content" auto-complete="off"></el-input>
              </el-form-item>
              <el-form-item label="月份" :label-width="formLabelWidth">
                <el-date-picker
                  v-model="createData1.time"
                  type="month"
                  value-format="yyyy-MM"
                  placeholder="选择月">
                </el-date-picker>
              </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
              <el-button @click="dialogFormVisible = false">取 消</el-button>
              <el-button type="primary" @click="saveDialog()">确 定</el-button>
            </div>
          </el-dialog>
          <!-- 添加赴日前时间轴 -->
          <el-dialog title="添加时间轴" :visible.sync="dialogFormVisible2">
            <el-form>
              <el-form-item label="阶段名称" :label-width="formLabelWidth">
                <el-input v-model="createData2.title" auto-complete="off"></el-input>
              </el-form-item>
              <el-form-item label="内容" :label-width="formLabelWidth">
                <el-input v-model="createData2.title_content" auto-complete="off"></el-input>
              </el-form-item>
              <el-form-item label="月份" :label-width="formLabelWidth">
                <el-date-picker
                  v-model="createData2.time"
                  type="month"
                  value-format="yyyy-MM"
                  placeholder="选择月">
                </el-date-picker>
              </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
              <el-button @click="dialogFormVisible2 = false">取 消</el-button>
              <el-button type="primary" @click="saveDialog2()">确 定</el-button>
            </div>
          </el-dialog>
        </div>
      </div>
    </div>
    <div v-show="shareLock" class="share-img-window" @click="closeShare">
      <img :src="this.shareImg" alt="">
      <h3>右键点击图片另存为</h3>
    </div>
  </div>
</template>

<script>

import crumbs from '@/components/tool/crumbs';
import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import 'quill/dist/quill.bubble.css';
import { quillEditor } from 'vue-quill-editor';
import QRCode from 'qrcode';

export default {
  data() {
    return {
      shareBg: require('@/assets/images/bg-qrcode-share.png'),
      shareImg: '',
      shareLock: false,
      crmId: null, // crmid参数
      tabShow: 1, // 显示模块索引,从1开始
      pageData: {
      },
      checkList: [],
      dataList: {
        info: {
          custom_name: '',

        },
        interview: {
          school_name: '',
          signup_form: {
            final_school: ''
          }
        },
        timeLine: {
          first: ''
        },
        plan: {
          expenditure: ''
        },
        school: {
          school_icon: '',
          school_officer: {
            picture_head: ''
          }
        }
      },
      dataChoose: 1,
      formLabelWidth: '120px',
      dialogFormVisible: false,
      createData1: {
      },
      flag1: 0,
      dialogFormVisible2: false,
      createData2: {
      },
      flag2: 0,
      link: '',
      editorOption: {
        placeholder: '请输入内容',
        modules: {
          toolbar: [
            ['bold', 'underline', 'strike'],
            [{ align: [] }],
            [{ size: ['small', false, 'large', 'huge'] }],
            [{ color: [] }, { background: [] }],
            ['image'],
            ['clean'],
          ]
        }
      },
    };
  },
  methods: {
    // 切换按钮点击
    tabClick(val) {
      this.tabShow = val;
    },
    // 上一步、下一步点击
    tabChange(val) {
      val === 1 ? this.tabShow-- : this.tabShow++;
      if (val === 2) {
        if (this.tabShow !== 5) {
          this.save(this.pageData, 1);
        } else {
          this.save(this.dataList.timeLine, 2);
        }
      }
    },
    // 复制链接
    copyLink() {
      let oInput = document.createElement('input');
      oInput.value = this.link;
      document.body.appendChild(oInput);
      oInput.select();
      console.log(oInput.value);
      document.execCommand('Copy');
      this.$message({
        message: '复制成功',
        type: 'success'
      });
      oInput.remove();
    },
    getInfo() {
      this.$http._post({
        url: '/index/Study_planning/getInfo',
        data: { crm_id: this.crmId },
      }).then((response) => {
        this.dataList = response.data;
        this.dataChoose = response.data.plan.school_type ? response.data.plan.school_type : '';
        this.pageData = response.data.plan;
        this.link = response.data.link;
      });
    },
    // 关闭推广图弹窗
    closeShare() {
      this.shareLock = false;
    },
    // 生成推广图
    makeQrcode() {
      let opts = {
        errorCorrectionLevel: 'H',
        type: 'image/jpeg',
        width: 180,
        margin: 0,
      };
      let that = this;
      QRCode.toDataURL(this.link, opts)
        .then((url) => {
          let canvas = document.createElement('canvas');
          canvas.width = 750;
          canvas.height = 1334;
          let context = canvas.getContext('2d');
          let myImage = new Image();
          myImage.src = that.shareBg;
          myImage.crossOrigin = 'Anonymous';
          myImage.onload = function() {
            context.drawImage(myImage, 0, 0, 750, 1334);
            let myImage2 = new Image();
            myImage2.src = url; // 你自己本地的图片或者在线图片
            myImage2.crossOrigin = 'Anonymous';
            myImage2.onload = function() {
              context.drawImage(myImage2, 285, 1013, 180, 180);
              let base64 = canvas.toDataURL('image/png');
              that.shareImg = base64;
            };
          };
          this.shareLock = true;
        })
        .catch((err) => {
          console.error(err);
          this.$message.error('图片合成失败');
        });
    },
    changeSchoolType(schoolType) {
      this.$http._post({
        url: '/index/Study_planning/changeSchoolType',
        data: {
          type: schoolType, crm_id: this.crmId, month: this.dataList.info.custom_month, year: this.dataList.info.custom_year, monthType: this.pageData.july_plan ? this.pageData.july_plan : ''
        }
      }).then((res) => {
        this.dataList.timeLine = res.data.timeLine;
        this.dataList.year = res.data.year;
        this.pageData.school_type = schoolType;
      });
    },
    changeSchoolType1(monthType) {
      this.$http._post({
        url: '/index/Study_planning/changeSchoolType',
        data: {
          type: this.dataChoose, crm_id: this.crmId, month: this.dataList.info.custom_month, year: this.dataList.info.custom_year, monthType: monthType
        }
      }).then((res) => {
        this.dataList.timeLine = res.data.timeLine;
        this.dataList.year = res.data.year;
      });
    },
    save(data, flag) {
      this.$http._post({
        url: '/index/Study_planning/save',
        data: {
          data: data, type: flag, crm_id: this.crmId, school_type: this.pageData.school_type
        }
      }).then((res) => {
        if (res.data === 1) {
          this.$message.success('保存成功');
        } else {
          this.$message.error('保存失败');
        }
      });
    },
    deleteItem(index) {
      this.dataList.timeLine.comment.splice(index, 1);
    },
    createdFirst(index) {
      if (index === 0) {
        index += 1;
      }
      this.dialogFormVisible = true;
      this.flag1 = index;
      this.createData1 = {};
    },
    createdSecond(index) {
      if (index === 0) {
        index += 1;
      }
      this.dialogFormVisible2 = true;
      this.flag2 = index;
      this.createData2 = {};
    },
    deletedFirst(index) {
      this.dataList.timeLine.first.splice(index, 1);
    },
    deletedSecond(index) {
      this.dataList.timeLine.second.splice(index, 1);
    },
    saveDialog() {
      let yearMonth = this.createData1.time.split('-');
      this.createData1.year = yearMonth[0];
      this.createData1.time = yearMonth[1];
      this.dataList.timeLine.first.splice(this.flag1, 0, this.createData1);
      this.dialogFormVisible = false;
    },
    saveDialog2() {
      let yearMonth = this.createData2.time.split('-');
      this.createData2.year = yearMonth[0];
      this.createData2.time = yearMonth[1];
      this.dataList.timeLine.second.splice(this.flag2, 0, this.createData2);
      this.dialogFormVisible2 = false;
    },
  },
  mounted() {
    // crmid赋值
    this.crmId = this.$route.params.id || null;
    this.getInfo();
  },
  components: {
    'jm-crumbs': crumbs,
    quillEditor,
    QRCode
  },
};
</script>

<style scoped>
  .quill-editor {
    height: 280px;
    margin-bottom: 40px;
  }
  .this-title{
    border-bottom: 1px solid #b8c4ce;
    line-height: 60px;
    display: flex;
    justify-content: flex-start;
    margin: 0 8px;
  }
  .this-title span{
    display: inline-block;
    width: 20%;
    font-size: 14px;
  }
  .this-process-area{
    padding: 20px 8px;
  }
  .this-process-area .process-area{
    display: inline-block;
    vertical-align: middle;
    height: 40px;
    line-height: 40px;
    background: rgba(51,104,250,.5);
    pointer-events: none;
    border-radius: 6px;
    padding: 0 15px;
    margin-right: 50px;
    position: relative;
    transition: all linear 0.2s;
  }
  .this-process-area .process-area.active{
    background: #3368fa;
    pointer-events: auto;
    cursor: pointer;
  }
  .this-process-area .process-area.active:hover{
    transform: scale(1.05);
  }
  .this-process-area .process-area.is-edit{
    background: #fec107;
  }
  .this-process-area .process-area span{
    color: #fff;
    font-size: 12px;
  }
  .this-process-area .process-area i{
    position: absolute;
    left: 100%;
    top: 50%;
    height: 1px;
    width: 50px;
    background: #b8c4ce;
  }
  .this-process-area .process-area.active i{
    background: #3368fa;
  }
  .this-content-wrap{
    padding: 0 8px 15px;
  }
  .this-content-wrap .this-content{
    border: 1px solid #b8c4ce;
    padding: 20px;
    border-radius: 8px;
  }
  .this-content-wrap .this-content > h3{
    font-size: 18px;
    font-weight: bold;
    color: #333;
    line-height: 36px;
    padding-bottom: 10px;
  }
  .this-content-wrap .this-content .content-text,.this-content-wrap .this-content .content-input{
    line-height: 50px;
  }
  .this-content-wrap .this-content .content-text em{
    color: #3368fa;
  }
  .this-btn-wrap{
    padding:0 8px 15px;
  }
  .this-content-wrap .this-content .teacher-area{
    text-align: center;
    width: 25%;
    display: inline-block;
    vertical-align: top;
  }
  .this-content-wrap .this-content .teacher-area h4{
    font-size: 16px;
    font-weight: normal;
    color: #3368fa;
  }
  .this-content-wrap .this-content .teacher-area img{
    max-width: 135px;
    display: inline-block;
    margin: 10px 0;
  }
  .this-content-wrap .this-content .teacher-area h5{
    font-size: 14px;
    font-weight: normal;
    padding: 10px 0;
  }
  .this-content-wrap .this-content .teacher-area p{
    font-size: 14px;
    line-height: 20px;
    color: #666;
  }
  .this-content-wrap .this-content .time-title{
    color: #3368fa;
    line-height: 40px;
    font-size: 16px;
    padding: 10px 0;
  }
  .this-content-wrap .this-content .time-wrap{
    width: 800px;
    position: relative;
  }
  .this-content-wrap .this-content .time-wrap .time-line{
    position: absolute;
    left: 50%;
    top: 0;
    height: 100%;
    width: 1px;
    background: #3368fa;
  }
  .this-content-wrap .this-content .time-wrap .time-content i{
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 8px;
    height: 8px;
    background: #3368fa;
    border-radius: 100%;
  }
  .this-content-wrap .this-content .time-wrap .time-content{
    padding: 20px 0;
    font-size: 14px;
    line-height: 20px;
    position: relative;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .this-content-wrap .this-content .time-wrap .time-content::after{
    clear: both;
    display: block;
    content: "";
  }
  .this-content-wrap .this-content .time-wrap .time-content .left-area{
    float: left;
    width: 50%;
    text-align: right;
    padding-right: 20px;
  }
  .this-content-wrap .this-content .time-wrap .time-content .right-area{
    float: right;
    width: 50%;
    text-align: left;
    padding-left: 20px;
  }
  .this-content-wrap .this-content .time-wrap .time-content .control-area{
    position: absolute;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
    text-align: left;
    width: 200px;
    font-size: 0;
  }
  .this-content-wrap .this-content .time-wrap .time-content .control-area span{
    display: inline-block;
    border-radius: 100%;
    width: 25px;
    height: 25px;
    line-height: 25px;
    background: #3368fa;
    color: #fff;
    text-align: center;
    font-size: 16px;
    margin-right: 10px;
    cursor: pointer;
  }
  .this-content-wrap .this-content .time-wrap .time-content .control-area span:last-of-type{
    background: red;
  }
  .this-content-wrap .this-content .time-endcontent{
    width: 800px;
    padding: 15px 0;
    text-align: center;
  }
  .memo-btn-wrap em{
    display: inline-block;
    vertical-align: middle;
    height: 40px;
    line-height: 40px;
    background: rgba(51,104,250,.1);
    border-radius: 6px;
    padding: 0 15px;
    margin-right: 8px;
    position: relative;
    transition: all linear 0.2s;
    color: #999;
    cursor: pointer;
  }
  .memo-btn-wrap em.active{
    background: #3368fa;
    color: #fff;
  }
  .memo-list-content{
    margin-top: 15px;
  }
  .memo-list-content .title-area{
    font-size: 14px;
    margin-bottom: 10px;
  }
  .memo-list-content .title-area span{
    color: red;
    cursor: pointer;
    margin-left: 30px;
  }
  .this-content-wrap .this-content .school-name{
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin-top: 15px;
  }
  .this-content-wrap .this-content .school-name img{
    width: 60px;
    height: 60px;
  }
  .this-content-wrap .this-content .school-name b{
    font-size: 22px;
    margin-left: 20px;
  }
  .this-content-wrap .this-content .school-title{
    font-size: 16px;
    margin: 15px 0 10px;
  }
  .this-content-wrap .this-content .school-content1 img{
    display: inline-block;
    vertical-align: top;
    width: 135px;
  }
  .this-content-wrap .this-content .school-content1 p{
    display: inline-block;
    vertical-align: top;
    max-width: 60%;
    margin-left: 20px;
  }
  .this-content-wrap .this-content .school-content2 img{
    display: inline-block;
    max-width: 23%;
    margin-right: 2%;
  }
  .this-content-wrap .this-content .school-content2 img:nth-of-type(4n){
    margin-right: 0;
  }
  .this-content-wrap .this-content .success-area{
    text-align: center;
    width: 100%;
    padding: 20px 0;
  }
  .this-content-wrap .this-content .success-area span{
    display: block;
    font-size: 18px;
    line-height: 35px;
    padding: 5px 0;
    color: #1abc9c;
  }
  .share-img-window{
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    background: rgba(0,0,0,.7);
    z-index: 9999;
    text-align: center;
  }
  .share-img-window img{
    display: inline-block;
    height: 85%;
  }
  .share-img-window h3{
    font-size: 16px;
    color:#fff;
    padding-top: 25px;
  }
</style>
